import Vue from 'vue';
import SampleRequestButton from './SampleRequestButton';

Vue.component('sample-request-button', SampleRequestButton);
